import { Component } from "@angular/core";
import { PolicyHeaderComponent } from "../policy-header/policy-header.component";

@Component({
  selector: "app-aul-006-24",
  standalone: true,
  imports: [PolicyHeaderComponent],
  templateUrl: "./aul-006-24.component.html",
  styleUrl: "./aul-006-24.component.scss",
})
export class Aul00624Component {}
